import React from 'react';

export const Input = (props) => (
    <input 
        {...props} 
        className={`w-full rounded-lg border p-2.5 text-sm outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${props.className || ''}`} 
    />
);

export default Input;
